'use strict';

const Ajax = require('common/infra/ajax');
const Mn = require('backbone.marionette');
const ActivationBodyTemplate = require('balus/ui/template/body/user-email-activation/index.hbs');
const ActivationTemplate = require('balus/ui/template/body/user-email-activation/activation.hbs');
const ModalView = require('common/ui/view/modal/index');
const UserSettingModal = require('common/ui/view/modal/user-setting');
const i18next = require('i18next');


const ActivationView = Mn.View.extend({
    template: ActivationTemplate,

    ui: {
        userSetting: '.user-setting'
    },
    events: {
        'click @ui.userSetting': 'showSetting'
    },

    templateContext: function() {
        const user = this.getOption('user');
        const success = this.getOption('success');
        const errorResponseType = this.getOption('errorResponseType');

        const token = this.getOption('token');
        const loginUrl = `/login?dst_url=/user-email-activate/${token}`;

        let showSigninButton = !user;
        let reasonCode = '';

        if (!user) {
            // 未ログインの場合
            reasonCode = 'no_login';
        } else if (errorResponseType === 'ObjectNotFoundError') {
            // ObjectNotFoundError の場合
            reasonCode = 'not_found';
        } else if (errorResponseType === 'TokenExpiredError') {
            reasonCode = 'expired';
        } else if (errorResponseType === 'ForbiddenError') {
            // ForbiddenError の場合 (「サインイン」ボタンを表示する)
            reasonCode = 'forbidden';
            showSigninButton = true;
        } else {
            // 原因不明のエラー表記
            reasonCode = 'default';
        }

        const errorReasonMessage = i18next.t(`balus_template_body_user_email_activation:index.lead.error.reason.${reasonCode}`);

        return {
            user: user,
            success: success,
            showSigninButton: showSigninButton,
            errorReasonMessage: errorReasonMessage,
            loginUrl: loginUrl,
        };
    },

    showSetting: function() {
        const user = this.getOption('user');
        const settingModal = new UserSettingModal({
            user: user,
            locationOnSuccess: '/',
        });
        const modal = new ModalView({
            model: user,
            title: i18next.t('title.user.setting'),
            saveButtonEnable: true,
            bodyView: settingModal,
            onChildviewSave: function() {
                this.disableButtons();
                settingModal.setting();
            }
        });
        modal.show();
    }
});

const ActivationBodyView = Mn.View.extend({
    template: ActivationBodyTemplate,

    regions: {
        activation: '.activation'
    },

    onRender: function() {
        const user = this.getOption('user');
        const token = this.getOption('token');

        Ajax.GET(`/api/user_emails/activate/${token}`).then(() => {
            this.showChildView('activation', new ActivationView({
                user: user,
                success: true,
                token: token,
            }));

            // 認証トークンでメールアドレスを有効化した後に、最新のユーザ情報を再取得する必要がある
            // ?reload=1 パラメータを付与してリダイレクトさせることで、ブラウザ内部状態を確実に更新する
            const location = window.location.href.split('?', 2);
            const reloaded = location.length >= 2 && location[1] === 'reload=1';
            if (! reloaded) {
                window.location.href = location[0] + '?reload=1';
            }

        }, (response) => {
            this.showChildView('activation', new ActivationView({
                user: user,
                success: false,
                token: token,
                errorResponseType: response.type,
            }));
        });
    }
});


module.exports = ActivationBodyView;



// WEBPACK FOOTER //
// ./balus/ui/view/body/user-email-activation/index.js